module.exports = __webpack_public_path__ + "static/media/team1.d840236d.jpg";